import React from "react";
import { UserType } from "#/api/oidc/oidcConfig";
import { useOidcUser } from "@axa-fr/react-oidc";
import { Button, Paragraph, Icon } from "@sicredi/react";
import styles from "./styles.module.scss";
import getFirstName from "#/utils/getFirstName";
import { usePoints } from "../../contexts/PointsContext/PointsContext";

export default function RedirectAccount() {
  const { oidcUser } = useOidcUser<UserType>();
  const points = usePoints();
  const dataPoints = points?.points.data?.actualQuantity;

  return (
    <div
      className={styles["button-area"]}
      onClick={() => {
        window.open(
          "https://shopping.sicredi.com.br/account#/",
          "_blank",
          "noopener, noreferrer"
        );
      }}
    >
      <div className={styles["button-login"]}>
        <Button className={styles["button-icon"]}>
          <Icon size={16} name="user" color={"#3FA111"} />
        </Button>
        <div className={styles["login-text"]}>
          <div className={styles["welcome"]}>
            <div className={styles["usergreeting"]}>
              Olá, {getFirstName(oidcUser?.name)}
            </div>
          </div>

          <div className={styles["links"]}>
            <Icon
              name="star"
              size={16}
              color="#3fa110"
              style={{ marginRight: 3, marginBottom: 3 }}
            />
            {dataPoints === undefined || dataPoints === null ? (
              <>Não foi possível buscar pontos</>
            ) : (
              <>
                Você tem{" "}
                <Paragraph className={styles["points"]}>
                  {dataPoints?.toLocaleString()}
                </Paragraph>{" "}
                pontos
              </>
            )}
          </div>
        </div>
        <div className={styles["chevroncontainer"]}>
          <Icon
            name="chevron-right"
            appearance="primary"
            data-testid="button-logout"
            className={styles["chevronicon"]}
          />
        </div>
      </div>
    </div>
  );
}
